import React, { Dispatch } from "react";
import { fetchToken } from "../../redux/actions/authActions";
import { connect } from "react-redux";
import LoginFormBase from "./LoginFormBase";
import { useTokenStore } from "../../stores/useTokenStore";
import { Link, Redirect } from "react-router-dom";
import strings from "../../languages/strings";
import { Box } from "@mui/material";

interface IProps {
  dispatch: Dispatch<any>;
}

const LoginForm = (props: IProps) => {
  let redirect = null;

  if (useTokenStore().refreshToken) {
    redirect = <Redirect to={"/"} />;
  }

  const handleSubmit = (values: any) => {
    props.dispatch(fetchToken(values.username, values.password));
  };

  return (
    <>
      {redirect}
      <LoginFormBase onSubmit={handleSubmit} />
      <Box my={2}>
        <Link
          style={{ color: "black", fontSize: 14 }}
          to="/app/requestpasswordreset"
        >
          {strings.passwordReset}
        </Link>
      </Box>
    </>
  );
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(LoginForm);
